<template>
    <div class="how-to">
        <h1 class="how-to__head">
            {{ getTranslatedText('Data Privacy and Cookie Policy') }}
        </h1>
        <div class="how-to__contents">
            <div v-if="isLoading" class="how-to__list-items__loading">
                <b-spinner />
            </div>
            <div v-if="!isLoading" class="how-to__list-items" :class="{active: isActiveContent}" id="abc">
                <div class="how-to__list-item">
                    {{ titleConditions }}
                    <img loading="lazy"
                        v-if="!isActiveContent"
                        @click="isActiveContent = !isActiveContent"
                        class="how-to__list-item__title-icon-down"
                        src="@/assets/images/static-pages/dropdown-how-to.png"
                    />
                    <img loading="lazy"
                        v-if="isActiveContent"
                        @click="isActiveContent = !isActiveContent"
                        class="how-to__list-item__title-icon-up"
                        src="@/assets/images/static-pages/icon-up-how-to.png"
                    />
                </div>
                <div
                    v-if="isActiveContent && cookiePolicy"
                    class="how-to__list-item__content cookies"
                    v-html="cookiePolicy"
                />
            </div>
        </div>
    </div>
</template>
<script>
import languageMixin from '@/mixins/language/language-mixin';
import CookiePolicy from "@/services/terms-conditions.service";
let scriptTag

export default {
    mixins: [languageMixin],
    components: {
    },
    data() {
        return {
            isActiveContent: true,
            cookiePolicy: '',
            titleConditions: '',
            isLoading: false
        };
    },
    created() {
      this.addScriptCanonical()
      this.getDataCookiePolicy();
    },
    beforeDestroy(){
        function removeScript(script) {
            if (script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
        }
        removeScript(scriptTag);
    },
    methods: {
        addScriptCanonical() {
            scriptTag = document.createElement("link");
            scriptTag.rel = "canonical";
            scriptTag.href =`https://omillionaire.com/data-privacy-and-cookie-policy`
            document.head.appendChild(scriptTag);
        },
        async navigateCookie() {
            const parameters = this.$route.query;
            if(parameters?.isCookie) {
                this.$router.replace({'query': null});
                const element = await this.cookiePolicy ? document?.getElementById('cookie-id') : null;                
                element.scrollIntoViewIfNeeded({ behavior: 'smooth', block: 'center', inline: 'center' });
            }          
        },
        getDataCookiePolicy() {
            this.isLoading = true;
            const locale = localStorage.getItem("locale");
            if(locale) {
                CookiePolicy.getCookiePolicy(locale).then((res) => {
                    if (res.status === 200) {
                        this.cookiePolicy = res.data.body;
                        this.titleConditions = res.data.title;
                        this.navigateCookie()
                    }
                    this.isLoading = false;
                });
            } else {
                CookiePolicy.getCookiePolicy('en').then((res) => {
                    if (res.status === 200) {
                        this.cookiePolicy = res.data.body;
                        this.titleConditions = res.data.title;
                        this.navigateCookie()
                    }
                    this.isLoading = false;
                });
            }
        }
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/static-pages/howto.scss" />
